/**
 * Download a file from R2 through the backend proxy.
 * Works for cross-origin R2 URLs that <a download> cannot handle.
 */
export async function downloadFile(url, token, isVideo = false) {
  const API_URL = process.env.REACT_APP_API_URL || '/api';
  const res = await fetch(`${API_URL}/download?url=${encodeURIComponent(url)}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error('Download failed');
  const blob = await res.blob();
  const ext = isVideo ? 'mp4' : 'png';
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = `aifield_${Date.now()}.${ext}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(a.href);
}
